export default __webpack_public_path__ + "media/images/mailer/wordmark-0cfd9ffaab97907c5979c6df1bbb70b6.png";